import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faCheck, faSearch, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import { RecordNavigationComponent } from '../_shared/record-navigation/record-navigation.component'
import { VerificationOfficeService } from '../../_services/verification-office.service'
import {
  VerificationOfficeLookupResult,
  VerificationOfficeOverview
} from '../../_models/verification-office.interface'

// Eichamt-Zuordnung im Admin-Bereich (siehe bentomax/hawk#574).
//
// Die Eichamt-Liste wird per Rake-Task eingespielt
// (rails verification_offices:import) und ist hier bewusst nur lesbar —
// es sind Behördenstammdaten, keine Arbeitsdaten.
//
// Das Instandsetzerkennzeichen liegt NICHT hier, sondern am einzelnen
// Techniker (Benutzerverwaltung). Es ist laut TKR eine Techniker-Eigenschaft,
// keine des Betriebs.
@Component({
  selector: 'app-scale-settings',
  standalone: true,
  imports: [FormsModule, FontAwesomeModule, RecordNavigationComponent],
  templateUrl: './scale-settings.component.html',
  host: { class: 'app-page' }
})
export class ScaleSettingsComponent implements OnInit {
  faCheck = faCheck
  faSearch = faSearch
  faExclamationTriangle = faExclamationTriangle

  overview: VerificationOfficeOverview | null = null
  loading = true

  postalCodeQuery = ''
  cityQuery = ''
  lookupResult: VerificationOfficeLookupResult | null = null
  lookupRunning = false

  constructor(private verificationOfficeService: VerificationOfficeService) {
  }

  ngOnInit(): void {
    this.loadOverview()
  }

  private loadOverview(): void {
    this.loading = true
    this.verificationOfficeService.getOverview().subscribe({
      next: overview => {
        this.overview = overview
        this.loading = false
      },
      error: () => {
        this.loading = false
      }
    })
  }

  public runLookup(): void {
    const plz = this.postalCodeQuery.trim()
    if (plz === '') {
      this.lookupResult = null
      return
    }

    this.lookupRunning = true
    this.verificationOfficeService.lookup(plz, this.cityQuery).subscribe({
      next: result => {
        this.lookupResult = result
        this.lookupRunning = false
      },
      error: () => {
        this.lookupResult = null
        this.lookupRunning = false
      }
    })
  }

  // Nur 'found' ist ein verwendbares Ergebnis — bei allen anderen Ausgängen
  // muss der Helpdesk ran, statt dass still nichts passiert.
  public get lookupOk(): boolean {
    return this.lookupResult?.status === 'found'
  }
}
